export default "__VITE_ASSET__Qr6aaGGC__"